/******* Angular Resourse *******/
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

/******* Plug-In Resourse *******/
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

/******* Core Resourse *******/
import { CoreCommonModule } from '@core/common.module';

/******* Components Resourse *******/
import { LoadMoreButtonComponent } from './load-more-button.component';

@NgModule({
    declarations: [LoadMoreButtonComponent],
    imports: [CommonModule, NgbModule, CoreCommonModule],
    exports: [LoadMoreButtonComponent]
})
export class LoadMoreButtonModule { }